export enum AuthRights 
{
    View= 'view',
    Create='create',
    Edit='edit',
    Delete='delete'
}


// WEBPACK FOOTER //
// ./src/app/auth/auth-rights.ts